import { render, staticRenderFns } from "./BrandCredibility.vue?vue&type=template&id=8179f46e&scoped=true&"
import script from "./BrandCredibility.vue?vue&type=script&lang=js&"
export * from "./BrandCredibility.vue?vue&type=script&lang=js&"
import style0 from "./BrandCredibility.vue?vue&type=style&index=0&id=8179f46e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8179f46e",
  null
  
)

export default component.exports